/** Internal-only helpers — not re-exported from the package barrel. */

/** Exit-animation duration matching `.dismissing` CSS (80ms under prefers-reduced-motion, 180ms otherwise). Evaluated at call-time. */
export function getExitAnimationMs(): number {
  if (typeof window === "undefined" || typeof window.matchMedia !== "function") return 180;
  return window.matchMedia("(prefers-reduced-motion: reduce)").matches ? 80 : 180;
}

/**
 * Resolve a row inside the list `<ul>` by its stable id: `data-msg-id` (regular
 * cards), `data-conv-key` (conversation threads), then the `#kbd-row-<id>`
 * wrapper (call cards omit `data-msg-id`). Returns null when the id isn't rendered.
 */
export function findRow(listEl: HTMLElement, id: string): HTMLElement | null {
  // esc() escapes only `"`/`\` for the attribute-value branches (CSS.escape would over-escape there);
  // the #kbd-row-<id> ID selector below uses CSS.escape — correct, since `#...` is an identifier context.
  const esc = (s: string) => s.replace(/["\\]/g, "\\$&");
  return (
    listEl.querySelector<HTMLElement>(`[data-msg-id="${esc(id)}"]`) ??
    listEl.querySelector<HTMLElement>(`[data-conv-key="${esc(id)}"]`) ??
    listEl.querySelector<HTMLElement>(`#kbd-row-${CSS.escape(id)}`)
  );
}
